import '../layout/theme';
import { logError } from '../utils/logging';
import { serviceHelper } from '../config/service-helper';
import React from 'react';
import { createRoot } from 'react-dom/client';
import GiftCardForm from '../components/gift-card/GiftCardForm';
import { drawDefaultLayout } from './components/layout/DefaultLayout';

/**
 * Inits Gift Card Product
 */
document.addEventListener('DOMContentLoaded', () => {
  /**
   * Updates the link to check the gift card balance to the set env variable.
   */
  const giftCardBalanceLink: HTMLAnchorElement | null = document.querySelector('.giftcard-balance a');

  if (giftCardBalanceLink) {
    giftCardBalanceLink.href = serviceHelper.giftCardPDPBalanceCheckUrl ?? '';
  }

  const giftCardFormContainer = document.querySelector('#GiftCardForm');

  const giftCardProductData = window?.Jbhifi?.giftCard;
  if (!giftCardFormContainer || !giftCardProductData) {
    logError('Gift card form container not found || gift card product data not defined.', undefined);
    return;
  }
  drawDefaultLayout();

  const root = createRoot(giftCardFormContainer);
  root.render(<GiftCardForm giftCardProduct={giftCardProductData} />);
});
